import { render, staticRenderFns } from "./LandingComponent.vue?vue&type=template&id=e5b7e3b4&scoped=true"
import script from "./LandingComponent.vue?vue&type=script&lang=js"
export * from "./LandingComponent.vue?vue&type=script&lang=js"
import style0 from "./LandingComponent.vue?vue&type=style&index=0&id=e5b7e3b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b7e3b4",
  null
  
)

export default component.exports